import { Box, Container, Typography } from '@mui/material';

import { ButtonLink } from '@components/navigation';
import { HOME } from '@navigation/routes.paths';

import type { PageComponent } from '../../pages.types';

export const Error403Page: PageComponent = () => {
  return (
    <Container data-testid='403_page'>
      <Box sx={{ textAlign: 'center', py: 8 }}>
        <Typography variant='display1'>403</Typography>
        <Typography variant='h1'>Доступ запрещён.</Typography>
        <Typography variant='h2' sx={{ mt: 2, mb: 4 }}>
          У вас нет прав для доступа к этой странице.
        </Typography>
        <ButtonLink to={HOME}>Вернуться на главную страницу</ButtonLink>
      </Box>
    </Container>
  );
};

export default Error403Page;
